/*@ngInject*/
const FormDropdownController = function ($scope, $controller, $q, $filter, $rootScope, coreConstant, formViewerConstant, formComponentUtil, preferenceModel, coreMediator, xmlUtil, formMediator, localization, modalUtil, loadingBarHandler, remoteFunction, dataSetType, functionActionUtil) {

    let splitKey = '::',
        itemLoading = {loading: true, disabled: true, 'name': null},
        itemLongList = {warning: true, disabled: true, 'name': null},
        searchPrompt,
        noMatchFound,
        dropdownExecutorDefaultConfirmYesButton,
        dropdownExecutorDefaultConfirmNoButton,
        dropdownExecutorDefaultConfirmTitle;

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}), $controller('baseDataSetFormComponentController', {$scope: $scope}));

    this.$onInit = function () {
        localization.setupLocale('formComponent', require('./formDropdown.i18n.json'));

        this.feedbackMessage = '';
        this.maximumDropdownSize = preferenceModel.get('system.maximumDropdownSize');

        let uiField = this.fieldStructure.uiField,
            fieldInstance = this.fieldStructure.fieldModel,
            dataSetImmediateLoad = this.fieldStructure.dynamicProperties.hasValue && _.isNil(fieldInstance.valueLabel),
            preventDataSetLoadIfConfigurableComponent = true;


        localization.getTranslationByKey('formsViewer.controls.dropdown').then((translation) => {
            itemLoading.name = _.get(translation, 'loading');
            itemLongList.name = _.get(translation, 'longListWarning');
            searchPrompt = _.get(translation, 'searchPrompt');
            noMatchFound = _.get(translation, 'noMatchFound');
            dropdownExecutorDefaultConfirmYesButton = _.get(translation, 'dropdownExecutorDefaultConfirmYesButton');
            dropdownExecutorDefaultConfirmNoButton = _.get(translation, 'dropdownExecutorDefaultConfirmNoButton');
            dropdownExecutorDefaultConfirmTitle = _.get(translation, 'dropdownExecutorDefaultConfirmTitle');
            this.setSearchCharLimit = (_.get(translation, 'searchCharLimit'));
        });

        this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(() => {
            let shouldSetDefaultItemListValue = this.fieldStructure.dynamicProperties.hasValue && this.isItemsListEmpty();

            if (shouldSetDefaultItemListValue) {
                // Because we don't load the dataset items on initialization for dynamic data set dropdowns,
                // we need to have a default item in the list if the field currently has a value
                this.setDefaultItemListValue();
            }

            this.updateDropdownSelectedValue(true);
        });

        this.fieldOptions = uiField.options ? xmlUtil.parseString(uiField.options) : {};

        this.isRegistered = false;
        this.dropdownSelectedValue = null;
        this.placeholder = this.fieldOptions.prompt || '';
        this.isDate = this.fieldStructure.uiField.fieldTemplate.validator === 'date';
        this.hasBusinessCard = this.fieldStructure.uiField.hasBusinessCard;
        this.hasOrganizationCard = this.fieldStructure.uiField.hasOrganizationCard;

        this.otherPromptLabelConfig = {
            label: this.fieldOptions.otherPrompt
        };

        this.isOtherTriggered = this.checkIfOtherTriggered(fieldInstance);

        this.isRowRepeaterComponent = this.fieldStructure.rowRepeaterId !== undefined;

        if (this.isRowRepeaterComponent) {
            this.dropdownComponentName = this.fieldStructure.rowRepeaterName + 'row' + this.fieldStructure.rowNumber + this.getComponentId(this.fieldStructure.uiField);

        } else {
            this.dropdownComponentName = this.getComponentId(this.fieldStructure.uiField);
        }

        this.dropdownExecutorEnabled = !!this.fieldOptions.dropdownExecutor;
        if (this.dropdownExecutorEnabled) {
            this.dropdownExecutorPrompt = this.fieldOptions.dropdownExecutorPrompt;
        }

        this.dropdownClassName = this.getComponentClassName(this.fieldStructure.uiField);

        this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
    };

    this.$onChanges = function (changes) {
        let timeLastModified = _.get(changes, 'timeLastModified');
        if (timeLastModified && !timeLastModified.isFirstChange()) {
            let fieldInstance = this.fieldStructure.fieldModel;

            this.onChanges();

            this.isOtherTriggered = this.checkIfOtherTriggered(fieldInstance);
            if (this.isItemsListEmpty() && this.fieldStructure.dynamicProperties.hasValue) {
                this.setDefaultItemListValue();
            }

            this.updateDropdownSelectedValue();
        }
    };

    this.isRequired = function () {
        const isRequired = this.fieldStructure.requiredIndicatorLabelConfig.required === true;
        const isOptionallyRequired = this.fieldStructure.dynamicProperties.isOptionallyRequired === false;

        return isRequired || isOptionallyRequired;
    };

    /*
     * this.handleFocus is set to baseFormComponentController.handleFocus
     * because of the above angular.extend call. save it in superHandleFocus
     * so that the handleFocus method below can call it.
     */
    this.superHandleFocus = this.handleFocus;
    this.handleFocus = function () {
        this.superHandleFocus();
        $rootScope.$broadcast(coreConstant.event.HIDE_FORM_TOOLTIP);

        if (!this.isRegistered && (_.isNil(this.fieldStructure.parentFormStructure) || !this.fieldStructure.parentFormStructure.isConfigurableForm)) {
            this.loadDataSet(true).then(() => {
                this.updateDropdownSelectedValue(true);

                if (this.minimumSearchLength === 1) {
                    this.minimumSearchLengthError = i18n.t('formComponent|dropdown.minimumSearchLengthMessage', {minChars: this.minimumSearchLength});
                } else {
                    this.minimumSearchLengthError = i18n.t('formComponent|dropdown.minimumSearchLengthMessage_plural', {minChars: this.minimumSearchLength});
                }

                if (this.supportSearch) {
                    this.validateRemoteSearch();
                }

                this.isRegistered = true;
            });
        } else {
            if (this.supportSearch) {
                this.validateRemoteSearch();
            }
        }
    };

    this.handleSelect = function (selectionOption) {
        this.dropdownSelectedValue = selectionOption;

        if (this.dropdownExecutorEnabled && !_.isNil(this.dropdownSelectedValue) && this.dropdownSelectedValue.isDropdownExecutor) {
            this.dropdownSelectedValue = null;

            this.execute();
        } else {
            this.fieldStructure.hasLocalChanges = true;
            this.updateOriginalFieldValue();

            if (this.dropdownSelectedValue) {
                if (!this.fieldStructure.fieldModel) {
                    this.fieldStructure.fieldModel = {};
                }

                this.fieldStructure.fieldModel.value = _.get(this.dropdownSelectedValue, 'value');
                this.fieldStructure.fieldModel.valueLabel = _.get(this.dropdownSelectedValue, 'name');
                this.isOtherTriggered = this.checkIfOtherTriggered(this.fieldStructure.fieldModel);
                if (this.isOtherTriggered) {
                    this.fieldStructure.fieldModel.value += (splitKey + _.toString(this.otherPromptValue));
                }
            } else {
                this.fieldStructure.fieldModel.value = null;
                this.fieldStructure.fieldModel.valueLabel = null;
            }

            formComponentUtil.setupFieldProperties(this.fieldStructure, this.formStructure.currencyCode);

            formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this));

            $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
        }
    };

    this.execute = function () {
        let formId = this.fieldStructure.parentForm.id,
            fieldId = this.fieldStructure.fieldModel ? this.fieldStructure.fieldModel.id : null,
            rowIndex = this.fieldStructure.rowNumber,
            submissionId = this.fieldStructure.parentForm.submissionId,
            config = {
                cancelButtonLabel: !_.isEmpty(this.fieldOptions.dropdownExecutorNoButtonLabel) ? this.fieldOptions.dropdownExecutorNoButtonLabel : dropdownExecutorDefaultConfirmNoButton,
                confirmActionButtonLabel: !_.isEmpty(this.fieldOptions.dropdownExecutorYesButtonLabel) ? this.fieldOptions.dropdownExecutorYesButtonLabel : dropdownExecutorDefaultConfirmYesButton,
                summary: this.fieldOptions.dropdownExecutorConfirmationMessage,
                title: !_.isEmpty(this.fieldOptions.dropdownExecutorConfirmationTitle) ? this.fieldOptions.dropdownExecutorConfirmationTitle : dropdownExecutorDefaultConfirmTitle
            },
            parameters = functionActionUtil.getParameterAsObject(this.fieldOptions.dropdownExecutorParameters);

        if (!_.isEmpty(this.fieldOptions.dropdownExecutorConfirmationMessage)) {
            modalUtil.showGenericConfirm(config).then(() => {
                if (!_.isEmpty(this.fieldOptions.dropdownExecutorProcessingIndicatorText)) {
                    loadingBarHandler.showLoadingBar(this.fieldOptions.dropdownExecutorProcessingIndicatorText);
                }
                executeContinue(submissionId, formId, fieldId, rowIndex, parameters);
            });
        } else {
            executeContinue(submissionId, formId, fieldId, rowIndex, parameters);
        }
    };

    function executeContinue(submissionId, formId, fieldId, rowIndex, parameters) {
        remoteFunction.executeFunction(formId, fieldId, rowIndex, parameters, submissionId).finally(function () {
            loadingBarHandler.hideLoadingBar();
        });
    }

    this.updateDropdownSelectedValue = function (showInvalid) {
        let fieldInstance = this.fieldStructure.fieldModel,
            value,
            otherValue,
            splittedValue,
            selectedValueIndex,
            selectedValue;

        if (this.fieldStructure.dynamicProperties.hasValue) {
            value = fieldInstance.value;

            this.isOtherTriggered = this.checkIfOtherTriggered(fieldInstance);
            if (this.isOtherTriggered) {
                splittedValue = fieldInstance.value.split('::');
                value = splittedValue[0];
                otherValue = splittedValue[1];
            }

            selectedValueIndex = _.findIndex(this.itemsList, {value: value});
            $scope.$broadcast(formViewerConstant.event.DROPDOWN_UPDATE_ACTIVE_INDEX, selectedValueIndex);

            if (selectedValueIndex !== -1) {
                selectedValue = this.itemsList[selectedValueIndex];
            }
            this.otherPromptValue = _.toString(otherValue);

            // Don't reset the selected value if it's a warning
            if (!_.isNil(selectedValue) && this.isSpecialMessageDisplayed) {
                return;
            }

            if (_.isNil(selectedValue)) {
                this.dropdownSelectedValue = {
                    name: fieldInstance.valueLabel,
                    value: fieldInstance.value,
                    ordering: -1
                };

                if (showInvalid) {
                    if (this.type !== dataSetType.STATIC && this.clearInvalidFieldValue) {
                        this.fieldStructure.fieldModel.value = '';
                        this.dropdownSelectedValue = null;
                        this.otherPromptValue = null;
                        this.handleSelect();
                    }
                    this.fieldStructure.dynamicProperties.isValid = false;
                }
            } else {
                this.dropdownSelectedValue = selectedValue;
            }
        } else {
            this.dropdownSelectedValue = null;
            this.otherPromptValue = null;
        }

        $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
    };

    this.updateItems = function (updateEvent, data) {
        if (this.shouldUpdateItems(updateEvent, data)) {
            this.setItemsList(data.items);
            this.updateDropdownSelectedValue(false);
        }
    };

    this.updateOriginalFieldValue = function () {
        if (this.fieldStructure.fieldModel) {
            this.origFieldValue = this.fieldStructure.fieldModel.value;
            this.origFieldValueLabel = this.fieldStructure.fieldModel.valueLabel;
        }
    };

    this.resetFieldValue = function () {
        this.fieldStructure.fieldModel.value = this.origFieldValue;
        this.fieldStructure.fieldModel.valueLabel = this.origFieldValueLabel;
        formComponentUtil.setupFieldProperties(this.fieldStructure, this.formStructure.currencyCode);
        this.updateDropdownSelectedValue(false);
    };

    this.setDefaultItemListValue = function () {
        let fieldInstance = this.fieldStructure.fieldModel,
            value = this.fieldStructure.fieldModel.value,
            splittedValue,
            item;
        this.isOtherPromptVisible = (this.fieldStructure.dynamicProperties.hasValue && this.fieldOptions.otherTrigger && (_.toString(fieldInstance.value).indexOf(this.fieldOptions.otherTrigger) === 0));
        if (this.isOtherPromptVisible) {
            splittedValue = fieldInstance.value.split('::');
            value = splittedValue[0];
        }
        item = {
            value: value,
            name: this.fieldStructure.fieldModel.valueLabel,
            ordering: 1
        };

        this.setItemsList([item]);
    };

    this.setItemsList = function (itemsList) {
        this.itemsList = _.cloneDeep(itemsList);
        this.filterItems();
    };

    this.validateRemoteSearch = function () {
        const searchLength = _.size(this.searchText);
        const hasMinimumSearchLengthError = searchLength < this.minimumSearchLength;

        if (hasMinimumSearchLengthError) {
            this.feedbackMessageOverride = this.minimumSearchLengthError;
        } else {
            this.feedbackMessageOverride = null;
        }
        this.makeRemoteSearch();
    };

    this.makeRemoteSearch = function () {
        this.loadDataSet(true);
    };

    this.checkIfOtherTriggered = function (fieldInstance) {
        return (fieldInstance && this.fieldOptions.otherTrigger && (_.toString(fieldInstance.value).split('::')[0] === (this.fieldOptions.otherTrigger)));
    }

    this.onSearch = function (searchText) {
        this.setSearchText(searchText);

        if (this.supportSearch) {
            this.validateRemoteSearch();
            const isValidSearch = _.isNil(this.feedbackMessageOverride);

            if (isValidSearch) {
                this.makeRemoteSearch();
            }
            this.makeRemoteSearch();
        } else {
            this.filterItems();
        }
    };

    this.filterItems = function () {
        const searchText = this.searchText;
        const hasSearch = !_.isEmpty(searchText);
        let filteredItemsList = [];

        if (!this.supportSearch) {
            if (hasSearch) {
                filteredItemsList = _.filter(this.itemsList, function (item) {
                    return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
                });
            } else {
                filteredItemsList = _.cloneDeep(this.itemsList);
            }
            this.filteredItemsList = filteredItemsList;
        } else {
            this.filteredItemsList = _.cloneDeep(this.itemsList);
        }
    };

    $scope.$on(coreConstant.event.UPDATE_DATA_SET, this.updateItems.bind(this));
};

angular.module('umFormViewer')
    .controller('formDropdownController', FormDropdownController);
